module.exports = __webpack_public_path__ + "static/media/roi-first-time-in-care.1c6451c5.png";